<!-- Модальная оболочка редактирования расхода: показывает форму и footer-действия. -->
<template>
  <base-modal
    :visible="true"
    title="Редактирование траты"
    size="xl"
    footer-align="start"
    elevated-footer
    @close="$emit('close')"
  >
    <ExpenseForm
      ref="expenseForm"
      :form-id="formId"
      :expense-id="expenseId"
      @close="$emit('close')"
      @expense-updated="$emit('expense-updated', $event)"
      @expense-deleted="$emit('expense-deleted')"
      @expense-accepted="$emit('expense-accepted', $event)"
      @submitting-change="isSubmitting = $event"
    />

    <template #footer>
      <base-primary-button
        type="submit"
        :form="formId"
        :disabled="isSubmitting"
        class="form-btn"
      >
        <span v-if="isSubmitting">Сохранение...</span>
        <span v-else>Сохранить</span>
      </base-primary-button>
      <base-button
        type="button"
        @click="$emit('close')"
        class="form-btn"
        :disabled="isSubmitting"
      >
        Отмена
      </base-button>
      <base-button
        type="button"
        @click="handleDelete"
        class="form-btn delete-btn"
        :disabled="isSubmitting"
      >
        Удалить
      </base-button>
    </template>
  </base-modal>
</template>

<script>
import ExpenseForm from "@/components/Expense/ExpenseForm.vue";

export default {
  name: "EditExpensesModal",

  components: {
    ExpenseForm,
  },

  props: {
    expenseId: {
      type: [String, Number],
      required: true,
    },
  },

  emits: [
    "close",
    "expense-updated",
    "expense-deleted",
    "expense-accepted",
  ],

  data() {
    return {
      formId: "edit-expense-form",
      isSubmitting: false,
    };
  },

  methods: {
    handleDelete() {
      this.$refs.expenseForm?.handleDelete();
    },
  },
};
</script>

<style scoped>
.delete-btn.delete-btn {
  margin-left: auto;
  border: 1px solid var(--color-danger);
  color: var(--color-danger);
  background-color: #fff;
}

.delete-btn.delete-btn:hover {
  background-color: var(--color-danger);
  color: #fff;
}
</style>
